import React from "react";

export default function Confidentialite() {
  return (
    <section className="bg-white py-14 lg:py-20 px-6 lg:px-10" data-testid="legal-privacy">
      <div className="max-w-3xl mx-auto">
        <p className="text-fegreen font-medium uppercase tracking-[0.25em] text-xs mb-3">— RGPD</p>
        <h1 className="text-3xl lg:text-5xl font-bold text-fegray-dark mb-10">Politique de confidentialité</h1>

        <div className="prose prose-sm lg:prose-base max-w-none text-fegray space-y-8">
          <section>
            <h2 className="text-xl font-bold text-fegray-dark mb-3">1. Responsable du traitement</h2>
            <p>
              FORM'ELEC — Rosalie Riveti, coach sportive, agréée Services à la Personne.<br />
              Contact RGPD : rosariveti@gmail.com — 07 66 25 31 43.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-fegray-dark mb-3">2. Données collectées</h2>
            <p>Dans le cadre de votre relation avec FORM'ELEC, nous collectons :</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li><strong>Identité</strong> : nom, prénom</li>
              <li><strong>Contact</strong> : email, téléphone, adresse postale</li>
              <li><strong>Données fiscales</strong> : email lié au compte fiscal (impots.gouv.fr) — uniquement pour l'avance immédiate URSSAF, avec votre consentement explicite</li>
              <li><strong>Données techniques</strong> : adresse IP, cookies de session</li>
              <li><strong>Données de santé</strong> (le cas échéant) : contre-indications déclarées, uniquement pour la sécurité de la séance</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-fegray-dark mb-3">3. Finalités &amp; bases légales</h2>
            <ul className="list-disc pl-5 space-y-1.5">
              <li><strong>Exécution du contrat</strong> : gestion des réservations et des paiements</li>
              <li><strong>Obligation légale</strong> : facturation, déclarations URSSAF, attestations fiscales</li>
              <li><strong>Consentement</strong> : avance immédiate de crédit d'impôt, newsletter</li>
              <li><strong>Intérêt légitime</strong> : amélioration du service, prévention de la fraude</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-fegray-dark mb-3">4. Durée de conservation</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Données client actif : durée de la relation contractuelle + 3 ans</li>
              <li>Factures &amp; attestations fiscales : 10 ans (obligation comptable)</li>
              <li>Données de prospection : 3 ans après dernier contact</li>
              <li>Cookies : 13 mois maximum</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-fegray-dark mb-3">5. Destinataires</h2>
            <p>Vos données ne sont jamais vendues. Elles sont communiquées uniquement à :</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li><strong>URSSAF / DGFiP</strong> : pour l'avance immédiate crédit d'impôt (avec votre consentement)</li>
              <li><strong>Stripe</strong> : prestataire de paiement sécurisé (PCI-DSS)</li>
              <li><strong>DigiPilote</strong> : hébergeur technique du site</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-fegray-dark mb-3">6. Vos droits</h2>
            <p>Conformément au RGPD, vous disposez à tout moment des droits suivants :</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Droit d'accès à vos données</li>
              <li>Droit de rectification</li>
              <li>Droit à l'effacement (« droit à l'oubli »)</li>
              <li>Droit à la portabilité</li>
              <li>Droit d'opposition</li>
              <li>Droit de retirer votre consentement à tout moment</li>
            </ul>
            <p className="mt-3">
              Pour exercer vos droits : <a href="mailto:rosariveti@gmail.com" className="text-fegreen font-semibold underline">rosariveti@gmail.com</a>.
              Vous pouvez également déposer une réclamation auprès de la CNIL :
              <a href="https://www.cnil.fr" target="_blank" rel="noreferrer" className="text-fegreen font-semibold underline ml-1">cnil.fr</a>.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-fegray-dark mb-3">7. Cookies</h2>
            <p>
              Le site utilise des cookies <strong>strictement nécessaires</strong> au fonctionnement
              (session de connexion, panier de réservation). Aucun cookie publicitaire ou de
              tracking tiers n'est déposé sans votre consentement.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-fegray-dark mb-3">8. Sécurité</h2>
            <p>
              Les données sont stockées sur des serveurs sécurisés dans l'Union Européenne.
              Les mots de passe sont chiffrés (bcrypt). Les communications utilisent le protocole HTTPS.
            </p>
          </section>
        </div>
      </div>
    </section>
  );
}
